import React from "react";
import { Table, Tag, Divider } from "antd";
import { ShoppingBag } from "lucide-react";

export const OrderItemsTable = ({ order }: any) => {
  const returnedQtyMap: Record<string, number> = {};

  (order?.returns || []).forEach((ret: any) => {
    (ret.items || []).forEach((ri: any) => {
      returnedQtyMap[ri.order_item_id] =
        (returnedQtyMap[ri.order_item_id] || 0) + ri.quantity;
    });
  });

  const column = [
    {
      title: "Product",
      key: "product",
      render: (_: any, rec: any) => (
        <div>
          <span className="font-semibold text-gray-800 text-xs">
            {rec.product_name}
          </span>
          <div className="text-[10px] text-gray-400 mt-0.5">
            SKU: {rec.sku_code || "N/A"} | Batch: {rec.batch_no || "N/A"}
          </div>
          {rec.description && (
            <div className="text-[10px] text-indigo-600 bg-indigo-50/40 border border-indigo-100 rounded px-1.5 py-0.5 mt-1 font-medium italic break-words max-w-[200px]">
              Note: {rec.description}
            </div>
          )}
          {(returnedQtyMap[rec.id] ?? 0) > 0 && (
            <Tag color="orange" className="mt-1 text-[9px]">
              {returnedQtyMap[rec.id]} returned
            </Tag>
          )}
        </div>
      ),
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
      render: (v: number) =>
        `LKR ${v.toLocaleString(undefined, { minimumFractionDigits: 2 })}`,
    },
    {
      title: "Qty",
      dataIndex: "quantity",
      key: "quantity",
      render: (v: number, rec: any) => (
        <Tag color="blue" className="font-semibold text-xs">
          {v} {rec.unit || ""}
        </Tag>
      ),
    },
    {
      title: "Discount",
      dataIndex: "discount_amount",
      key: "discount_amount",
      render: (v: number) =>
        v > 0
          ? `-LKR ${v.toLocaleString(undefined, { minimumFractionDigits: 2 })}`
          : "-",
    },
    {
      title: "Sold Price",
      dataIndex: "sold_price",
      key: "sold_price",
      render: (v: number) =>
        v > 0
          ? `LKR ${v.toLocaleString(undefined, { minimumFractionDigits: 2 })}`
          : "-",
    },
    {
      title: "Total Price",
      dataIndex: "total_price",
      key: "total_price",
      render: (v: number) => (
        <span className="font-bold text-gray-800 text-xs">
          LKR{" "}
          {v.toLocaleString(undefined, {
            minimumFractionDigits: 2,
          })}
        </span>
      ),
    },
  ];
  return (
    <>
      <div>
        <h3 className="text-xs font-bold text-gray-800 mb-2 flex items-center gap-1.5">
          <ShoppingBag className="w-3.5 h-3.5 text-gray-400" />
          Sold Product Items ({order.items?.length || 0})
        </h3>
        <Table
          dataSource={order.items || []}
          columns={column}
          pagination={{ pageSize: 10, size: "small" }}
          size="small"
          rowKey="id"
          bordered
        />
      </div>
    </>
  );
};
